import { render, staticRenderFns } from "./BusinessTaxReturn.vue?vue&type=template&id=3375b352&scoped=true&"
import script from "./BusinessTaxReturn.vue?vue&type=script&lang=ts&"
export * from "./BusinessTaxReturn.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTaxReturn.vue?vue&type=style&index=0&id=3375b352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3375b352",
  null
  
)

export default component.exports